var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.isToBrowser),expression:"isToBrowser"}],staticClass:"home-bg"},[_c('img',{attrs:{"src":require("@/assets/images/download/to.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }